// extracted by mini-css-extract-plugin
export default {"Banner":"style_Banner__s6YbV"};